import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useMaterialContext() {
  const { materials } = useContext<GlobalContextType>(GlobalContext);
  return materials;
}
